import React from 'react';
import { ProducerApp } from '../../producer/ProducerApp';

/** Every non-admin user is a producer: they see their own deals, and nothing financial. */
export const ViewerHome: React.FC = () => <ProducerApp />;
